import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: ['activity'],
})
export default class AboutActivityComponent extends Vue {
  currentAccordion = 'Details';

  toggleAccordion(name) {
    if (this.currentAccordion === name) {
      this.currentAccordion = '';
    } else {
      this.currentAccordion = name;
    }
  }
}
